/**
 * Converts a consent value to a standardized string format
 * - String values are returned as-is
 * - Boolean true becomes "1"
 * - Any other value becomes "0"
 */
export const formatConsentValue = (
  consent: boolean | string | undefined
): string => {
  if (typeof consent === 'string') return consent;
  return consent === true ? '1' : '0';
};
